<template>
  <div class="form-group">
    <div class="item-name">
      <label>性別</label>
    </div>
    <div class="button-style">
      <button v-bind:class="[activeButton === 0 ? 'active' : '']" @click=" selectGender(male); activeButton = 0;">
        男性
      </button>
      <button v-bind:class="[activeButton === 1 ? 'active' : '']" @click=" selectGender(female); activeButton = 1;">
        女性
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      male: "男",
      female: "女",
      gender: "",
      activeButton: "",
    }
  },
  methods: {
    selectGender(value) {
      this.gender = value;
      this.$emit('handle-change-gender', this.gender)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/molecules/InputGender.vue